import { debounceMs } from '../../../pages/manage-bookings/_utils/definitions-config';
import customKycFilter from './kycStatusFilter';
import { styledDefaultColDef } from '../../../extras/cellRenderers';

export const kycFilters = {
  PENDING: 'Waiting For Kyc',
  APPROVED: 'Completed',
  REJECTED: 'Rejected',
  UPLOADED: 'Uploaded',
};

export const columnDefs = [
  { field: 'userId', hide: true },
  {
    headerName: 'Name',
    field: 'User',
    flex: 1,
    suppressSizeToFit: true,
    valueFormatter: (params) =>
      [params.data.User?.firstName, params.data.User?.lastName].join(' '),
    // suppressAndOrCondition: true,
  },
  {
    headerName: 'Email Id',
    field: 'User',
    flex: 1,
    suppressSizeToFit: true,
    valueFormatter: (params) => params.data.User?.email,
    // suppressAndOrCondition: true,
  },
  {
    headerName: 'KYC Status',
    field: 'kycStatus',
    flex: 1,
    filter: customKycFilter,
    filterParams: {
      suppressSelectAll: true,
      defaultToNothingSelected: true,
      values: Object.keys(kycFilters),
      valueFormatter: (params) => {
        return kycFilters[params.value];
      },
      debounceMs: debounceMs,
    },
    suppressSizeToFit: true,
    valueFormatter: (params) => {
      const kycDetail = params.data.User.KycDetail;
      if (!kycDetail) return 'Waiting for KYC';
      switch (kycDetail.status) {
        case 'UPLOADED':
          return 'Uploaded';
        case 'APPROVED':
          return 'Completed';
        case 'REJECTED':
          return 'Rejected';
      }
    },
    cellStyle: (params) => {
      const kycDetail = params.data.User.KycDetail;
      const getColor = () => {
        if (!kycDetail) return '#0096FF';
        switch (kycDetail.status) {
          case 'UPLOADED':
            return '#EC7622';
          case 'APPROVED':
            return '#4C9D8A';
          case 'REJECTED':
            return '#FF6464';
        }
      };
      return {
        fontWeight: '400',
        color: getColor(),
      };
    },
    // suppressAndOrCondition: true,
  },
  {
    headerName: 'Actions',
    pinned: 'right',
    sortable: false,
    filter: false,
    cellStyle: {
      'border-left-color': 'transparent',
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    // suppressMenu: true,
    width: 120,
    cellRenderer: 'LinkCellRenderer',
  },
];

export const defaultColDef = {
  ...styledDefaultColDef,
  resizable: true,
};
